import {autoserializeAs, inheritSerialization} from 'cerialize';
import {ModelBase} from './model-base';
import {RsvpPerson} from './rsvp-person';

@inheritSerialization(ModelBase)
export class Rsvp extends ModelBase {
  public static readonly type = 'Rsvp';
  public readonly type = Rsvp.type;

  @autoserializeAs('id')
  public id: number;

  @autoserializeAs('user_id')
  public userId: number;

  @autoserializeAs('already_registered')
  public alreadyRegistered = false;

  @autoserializeAs(RsvpPerson, 'rsvp_people')
  public rsvpPeople = [];

  public getUserRsvpPerson(): RsvpPerson {
    return this.rsvpPeople.find(rsvpPerson => rsvpPerson.isUser);
  }
  
  public getNonUserRsvpPeople(): RsvpPerson[] {
    return this.rsvpPeople.filter(rsvpPerson => !rsvpPerson.isUser);
  }
}
